import lookup_table from '../water_use_lookup.json';
import getCropName from '../cropNameLookup';

export default function getLookupValues(crops, station, soil, unit, language) {
  // weather station name with capitalized first letter
  station = station[0].toUpperCase() + station.slice(1);
  // convert soil code to string
  soil = soil.toString();

  // store lookup values for each crop
  let crop_lookup_values = {};
  // fetch lookup values for each crop
  crops.forEach((crop) => {
    const cropName =
      language !== 'en' ? getCropName(language, crop.name) : crop.name;
    const lookup_values = lookup_table[station][soil][cropName];

    crop_lookup_values[crop.name] = {
      monthsGrown: null,
      yield: null,
      growingWater: null,
      monthlyWater: null,
    };

    crop_lookup_values[crop.name].monthsGrown = lookup_values['Months grown'];
    crop_lookup_values[crop.name].yield =
      lookup_values['Typical Crop Yield (tonnes/ha)'];
    crop_lookup_values[crop.name].growingWater =
      unit === 'ha'
        ? lookup_values['growing season water needs (m^3/ha)']
        : lookup_values['growing season water needs (m^3/topos)'];
    crop_lookup_values[crop.name].monthlyWater =
      unit === 'ha'
        ? lookup_values['monthly water needs (m^3/month/ha)']
        : lookup_values['monthly water needs (m^3/month/topos)'];
  });

  return crop_lookup_values;
}
